exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3aUfdRiwd8Ml4s6N40usI-{display:\"inline-block\";font-style:\"normal\";font-weight:\"normal\";overflow:\"hidden\";text-overflow:\"ellipsis\"}html[dir=ltr] ._36woXSbaQKHO_bKLV1V0O3{margin-right:6px}html[dir=rtl] ._36woXSbaQKHO_bKLV1V0O3{margin-left:6px}", ""]);
// Exports
exports.locals = {
	"title": "_3aUfdRiwd8Ml4s6N40usI-",
	"image": "_36woXSbaQKHO_bKLV1V0O3"
};